<template>
  <div class="swiper swiper-container">
    <slot name="top">
      <div class="swiper-gradient" />
      <div class="swiper-gradient" />
      <div
        v-if="options.navigation && options.navigation.prevEl"
        class="swiper-arrow swiper-arrow--prev products__slider-prev"
      />
      <div
        v-if="options.navigation && options.navigation.nextEl"
        class="swiper-arrow swiper-arrow--next products__slider-next"
      />
      <div
        v-if="options.pagination && !hasPaginationSlot"
        class="swiper-pagination"
      />
    </slot>
    <div class="swiper-wrapper">
      <slot />
    </div>
    <slot name="pagination" />
    <slot name="bottom" />
  </div>
</template>

<script>
import Swiper from 'swiper'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'

export default {
  name: 'Swiper',
  props: {
    options: {
      type: Object,
      default: () => ({
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 600,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        autoplay: false,
        navigation: {
          nextEl: '.swiper-arrow--next',
          prevEl: '.swiper-arrow--prev',
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            loop: false,
          },
          640: {
            slidesPerView: 2,
            loop: false,
          },
          992: {
            slidesPerView: 3,
            loop: false,
          },
        },
      }),
    },
  },
  data() {
    return {
      swiper: null,
    }
  },
  computed: {
    hasPaginationSlot() {
      return Boolean(this.$slots.pagination)
    },
  },
  mounted() {
    const modules = []
    if (this.options.pagination) {
      modules.push(Pagination)
    }
    if (this.options.navigation) {
      modules.push(Navigation)
    }
    if (this.options.autoplay) {
      modules.push(Autoplay)
    }

    this.swiper = new Swiper(this.$el, {
      modules,
      ...this.options,
    })
  },
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true)
      this.swiper = null
    }
  },
}
</script>
